import React, { useContext, useState } from "react";
import ModalLayout from "./ModalLayout";
import { useModalStyle } from "../../../styles/styleModal";
import {
  Box,
  Button,
  FormControl,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import { AddCircle, Delete } from "@mui/icons-material";

import AlertaContext from "../../../Context/Alerta/AlertaContext";
import MuiPhoneNumber from "material-ui-phone-number";
import { isValidNumber } from "libphonenumber-js";
import clienteAxios from "../../../config/axios";
import { useEffect } from "react";
export const ModalContactoPlantillaW = ({
  open,
  setopen,
  newContacto,
  setNewContacto,
  contactoDefault,
  row,
  objetoPlantilla,
  encabezado,
  personaId,
}) => {
  const clases = useModalStyle();
  const [cargando, setcargando] = useState(false);
  const { mostrarAlerta } = useContext(AlertaContext);
  const onDefault = () => {
    setopen(false);
    setNewContacto(contactoDefault);
  };
  const reemplazarValores = (plantilla, valores) => {
    let resultado = plantilla;
    for (let valor of valores) {
      let regex = new RegExp(`{{ ${valor.nombre} }}`, "g");
      resultado = resultado.replace(regex, valor.campo);
    }
    return resultado;
  };
  const getNumeros = async () => {
    try {
      const res = await clienteAxios(`/proveedores/${personaId}`);

      setNewContacto((prev) => ({
        ...prev,
        contacto: res.data.data[0].perCelular,
      }));
    } catch (error) {}
  };
  useEffect(() => {
    const getPlantilla = async () => {
      try {
        const res = await clienteAxios(
          `/empresas/plantilla/${objetoPlantilla}`
        );

        const valores = res.data.variables.map((variable) => ({
          campo: row[variable.campo],
          nombre: variable.nombre,
        }));

        setNewContacto((prev) => ({
          ...prev,
          contenidoMensaje: reemplazarValores(res.data.plantilla, valores),
        }));
      } catch (error) {
        mostrarAlerta("No hay plantilla");
        setopen(false);
      }
    };
    getPlantilla();
    getNumeros();
    // eslint-disable-next-line
  }, []);

  return (
    <ModalLayout
      open={open}
      defaultActive={onDefault}
      titulo={`Medio de comunicación: ${newContacto.medioComunicacion}`}
      id="ModalComunicacion"
    >
      <Box className={clases.container}>
        {encabezado.map((header) => (
          <FormControl className={clases.formAllW}>
            <Typography variant="subtitle1" color="primary">
              {header.label}{" "}
              <Typography
                variant="subtitle1"
                color="secondary"
                component="span"
              >
                {header.value}
              </Typography>
            </Typography>
          </FormControl>
        ))}
        <FormControl className={clases.formAllW}>
          <Box display="flex" alignItems="center">
            <Typography variant="subtitle1" color="primary">
              Contactos:
            </Typography>
            <IconButton
              size="small"
              onClick={() => {
                setNewContacto({
                  ...newContacto,
                  contacto: ["", ...newContacto.contacto],
                });
              }}
            >
              <AddCircle fontSize="small" color="secondary" />
            </IconButton>
          </Box>
        </FormControl>
        {newContacto.contacto.map((contacto, index) => {
          if (newContacto.medioComunicacion === "Correo") {
            return (
              <TextField
                className={clases.formD}
                value={contacto}
                onChange={(e) => {
                  setNewContacto({
                    ...newContacto,
                    contacto: newContacto.contacto.map(
                      (contacto, indexItem) => {
                        if (indexItem === index) {
                          return e.target.value;
                        } else {
                          return contacto;
                        }
                      }
                    ),
                  });
                }}
                type="email"
                label={`${
                  newContacto.medioComunicacion === "Correo"
                    ? "Correos"
                    : "Contactos"
                } #${index}`}
                InputProps={{
                  endAdornment: (
                    <InputAdornment>
                      <IconButton
                        onClick={() => {
                          setNewContacto({
                            ...newContacto,
                            contacto: newContacto.contacto.filter(
                              (contacto, indexItem) => {
                                return indexItem !== index;
                              }
                            ),
                          });
                        }}
                      >
                        <Delete color="error" />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            );
          }
          return (
            <MuiPhoneNumber
              defaultCountry={"ec"}
              regions={"america"}
              className={clases.formD}
              value={contacto}
              onChange={(e) => {
                setNewContacto({
                  ...newContacto,
                  contacto: newContacto.contacto.map((contacto, indexItem) => {
                    if (indexItem === index) {
                      return e;
                    } else {
                      return contacto;
                    }
                  }),
                });
              }}
              type="tel"
              label={`${
                newContacto.medioComunicacion === "Correo"
                  ? "Correos"
                  : "Contactos"
              } #${index}`}
              InputProps={{
                endAdornment: (
                  <InputAdornment>
                    <IconButton
                      onClick={() => {
                        setNewContacto({
                          ...newContacto,
                          contacto: newContacto.contacto.filter(
                            (contacto, indexItem) => {
                              return indexItem !== index;
                            }
                          ),
                        });
                      }}
                    >
                      <Delete color="error" />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          );
        })}
        <TextField
          color="secondary"
          multiline
          minRows={3}
          variant="outlined"
          className={clases.formAllW}
          label="Mensaje"
          value={newContacto.contenidoMensaje}
          name="correoResp"
        />
      </Box>

      <Box
        display="flex"
        width="100%"
        justifyContent="space-between"
        alignItems="center"
      >
        <Box width="100%" display="flex" justifyContent="flex-end" mt={1}>
          <Button
            style={{ width: "30%" }}
            variant="contained"
            color="primary"
            disabled={cargando}
            onClick={async () => {
              try {
                if (
                  newContacto.contacto.some(
                    (contact) => contact === "" || !isValidNumber(contact)
                  ) ||
                  newContacto.contacto.length === 0
                ) {
                  return mostrarAlerta("Error en los contactos", "error");
                }

                setcargando(true);
                const res = await clienteAxios.post("/mensajeria", newContacto);
                mostrarAlerta(res.data.msg, "success");
                setcargando(false);
              } catch (error) {
                mostrarAlerta("Hubo un error", "error");
                setcargando(false);
              }
            }}
          >
            Enviar
          </Button>
        </Box>
      </Box>
    </ModalLayout>
  );
};
